/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes recent versions of Safari, Chrome (including
 * Opera), Edge on the desktop, and iOS and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.


/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * SAN-207 (SC-SAAS-FRONTEND-3C) -- Array/String.prototype.at() is ES2022 and
 * missing on some in-app-browser WebView engines still seen in production
 * traffic (confirmed: Instagram's Android in-app browser threw
 * "this.o.at is not a function" on /programs/apply/... -- an "evergreen
 * browsers" assumption this app makes elsewhere, per the comment above,
 * doesn't hold for that traffic). Feature-detected so it's a no-op on every
 * browser that already has native .at().
 */
/* tsconfig's lib is ES2021, which has no .at() typings -- cast through
   any rather than bumping the lib target just for this one method. */
const arrayProto = Array.prototype as any;
if (!arrayProto.at) {
  // eslint-disable-next-line no-extend-native
  arrayProto.at = function (index: number): unknown {
    const length = this.length;
    const relativeIndex = Math.trunc(index) || 0;
    const actualIndex = relativeIndex < 0 ? length + relativeIndex : relativeIndex;
    return actualIndex >= 0 && actualIndex < length ? this[actualIndex] : undefined;
  };
}
const stringProto = String.prototype as any;
if (!stringProto.at) {
  // eslint-disable-next-line no-extend-native
  stringProto.at = function (index: number): string | undefined {
    const length = this.length;
    const relativeIndex = Math.trunc(index) || 0;
    const actualIndex = relativeIndex < 0 ? length + relativeIndex : relativeIndex;
    return actualIndex >= 0 && actualIndex < length ? this[actualIndex] : undefined;
  };
}

